import React from "react";

export const List = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 14.1667H17.5M2.5 16.6667H10.8333M5.16667 11.6667H14.8333C15.7668 11.6667 16.2335 11.6667 16.59 11.485C16.9036 11.3252 17.1586 11.0703 17.3183 10.7567C17.5 10.4001 17.5 9.93342 17.5 9V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84144 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5H5.16667C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667V9C2.5 9.93342 2.5 10.4001 2.68166 10.7567C2.84144 11.0703 3.09641 11.3252 3.41002 11.485C3.76654 11.6667 4.23325 11.6667 5.16667 11.6667Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />

      <path
        d="M2.5 14.1667H17.5M2.5 16.6667H10.8333M5.16667 11.6667H14.8333C15.7668 11.6667 16.2335 11.6667 16.59 11.485C16.9036 11.3252 17.1586 11.0703 17.3183 10.7567C17.5 10.4001 17.5 9.93342 17.5 9V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84144 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5H5.16667C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667V9C2.5 9.93342 2.5 10.4001 2.68166 10.7567C2.84144 11.0703 3.09641 11.3252 3.41002 11.485C3.76654 11.6667 4.23325 11.6667 5.16667 11.6667Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  );
};